// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3xyg2","rootSmall":"AddTileButton_rootSmall__14PLu"};